(function () {
  'use strict';

  /* ---------- mobile nav ---------- */
  var navToggle = document.getElementById('navToggle');
  var mainNav = document.getElementById('mainNav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', function () {
      var open = mainNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mainNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mainNav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- product media thumbnails ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function (e) {
      var main = thumb.closest('.product-main') && thumb.closest('.product-main').querySelector('.product-media img');
      if (!main) return;
      e.preventDefault();
      main.src = thumb.getAttribute('href');
    });
  });

  /* ---------- product variant selection ---------- */
  document.querySelectorAll('.product-form').forEach(function (form) {
    var productId = form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').id.replace('ProductVariantId-', '');
    if (!productId) return;
    var variants = (window.__productVariants && window.__productVariants[productId]) || null;
    var selects = form.querySelectorAll('.js-product-option');
    if (!variants || !selects.length) return;

    var hiddenInput = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var priceEl = document.getElementById('ProductPrice-' + productId);

    function money(cents) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function currentSelection() {
      var vals = [];
      selects.forEach(function (s) { vals[+s.dataset.position - 1] = s.value; });
      return vals;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return sel.every(function (val, i) { return val === undefined || val === opts[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      hiddenInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = priceEl.dataset.showPrices === 'false' ? 'Prijs op aanvraag' :
          (variant.compare_at_price && variant.compare_at_price > variant.price ? '<del>' + money(variant.compare_at_price) + '</del> ' : '') + money(variant.price);
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Toevoegen aan winkelwagen' : 'Niet beschikbaar';
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', updateUI); });
  });
})();
